import { Button, Divider, Form, Input, Table, message } from "antd";
import { layoutForms } from "../../../component/utility";
/////Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import Url from "../../../apiCall/UrlConfig";
import { useEffect } from "react";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const PrecentationTreshhold = 20;
const ReportExam = (props) => {
  const [form] = Form.useForm();
  const Columns = [
    { title: "کد", dataIndex: "id", key: "id" },
    { title: "نام دانشجو", dataIndex: "name", key: "name" },
    { title: "شماره دانشجویی", dataIndex: "studentCode", key: "studentCode" },
    {
      title: "مشاهده ویدیو",
      dataIndex: "studentCode",
      key: "studentCode",
      render: (_, item) => {
        if (item.isSawDemo) {
          return (
            <div>
              <CheckOutlined style={{ color: "green" }} />
            </div>
          );
        } else {
          return (
            <div>
              <CloseOutlined style={{ color: "red" }} />
            </div>
          );
        }
      },
    },
    // {
    //   title: "بررسی آزمون",
    //   dataIndex: "analyses",
    //   key: "analyses",
    //   render: (_, item) => {
    //     if (item.isSawDemo) {
    //       return (
    //         <Button onClick={() => _onClickAnalysesExam(item)}>
    //           آنالیز آزمون
    //         </Button>
    //       );
    //     }
    //   },
    // },
  ];

  const ColumnListExam = [
    { title: "کد", dataIndex: "id", key: "id" },
    {
      title: "تصویر",
      dataIndex: "name",
      key: "name",
      render: (_, item, index) => {
        return (
          <div>
            <img src={ImagePreAddress + item.imageUrl} width={50} />
          </div>
        );
      },
    },
    {
      title: "تحلیل آزمون",
      dataIndex: "studentCode",
      key: "studentCode",
      render: (_, item) => {
        return _renderAnalyses(item);
      },
    },
  ];
  const _getListStudent = async () => {
    let url = Url.getStudentList;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  useEffect(() => {
    _getListStudent();
  }, []);

  const _renderAnalyses = (item) => {
    let NumberGoldStandard = item?.refrenceImageDetails?.length;
    let NumberStudentDignos = item?.studentImageDetails?.length;
    let NumberCorectStudent = item?.reportExamList.filter(
      (o) => o.precentMatching > PrecentationTreshhold
    ).length;

    let NumberNotDignose = item?.reportExamList.filter(
      (o) => o.examImageDetailId == -1
    ).length;

    let NumberDignoseIncorect = item?.reportExamList.filter(
      (o) =>
        o.examImageDetailId > -1 && o.precentMatching < PrecentationTreshhold
    ).length;

    return (
      <div>
        <div>تعداد تشخیص استاد = {NumberGoldStandard}</div>
        <div>تعداد تشخیص دانشجو = {NumberStudentDignos}</div>
        <div>تعداد تشخیص صحیح دانشجو = {NumberCorectStudent}</div>
        <div>تعداد عدم تشخیص دانشجو = {NumberNotDignose}</div>
        <div>تعداد تشخیص غلط دانشجو = {NumberDignoseIncorect}</div>
      </div>
    );
  };
  const _onClickRowStudent = async (item) => {
    console.log(item);

    let url = Url.GetImageDetailForStudent;

    let res = await props.actions.CallCoreServicesActionWithToken(url, item);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  const _ReturnExpandRow = (record) => {
    let _HbeW = record?.imageHeight / record?.imageWidth;
    let _imageSize = 300;
    return (
      <div dir="ltr" className="expandRowForDetailExam">
        <div>
          <Divider>تشخیص دانشجو</Divider>
          {record?.studentImageDetails.map((o) => {
            let Report = record?.reportExamList.find(
              (t) => t.numberTooth == o.numberTooth && t.type == o.typeDetail
            );

            return (
              <div>
                <div className="text-center">
                  {o.numberTooth} {"==>"} {o.typeDetail}
                </div>
                <div
                  className="text-center"
                  style={{
                    color: Report?.precentMatching > 20 ? "green" : "red",
                  }}
                >
                  {" "}
                  تطابق {Report?.precentMatching} درصد
                </div>
                <img
                  src={o.base64Masked}
                  style={{
                    backgroundImage:
                      "url(" + ImagePreAddress + record.imageUrl + ")",
                    backgroundSize: "cover",
                  }}
                  width={_imageSize}
                  height={_HbeW * _imageSize}
                />
              </div>
            );
          })}
          {/* <Table dataSource={record?.studentImageDetails}></Table> */}
        </div>
        <div>
          <Divider>تشخیص استاد</Divider>
          {record?.refrenceImageDetails.map((o) => {
            let Report = record?.reportExamList.find(
              (t) => t.numberTooth == o.numberTooth && t.type == o.typeDetail
            );

            return (
              <div>
                <div className="text-center">
                  {o.numberTooth} {"==>"}
                  {o.typeDetail}
                </div>
                <div
                  className="text-center"
                  style={{
                    color: Report?.precentMatching > 20 ? "green" : "red",
                  }}
                >
                  تطابق {Report?.precentMatching} درصد
                </div>
                <img
                  src={o.base64Masked}
                  style={{
                    backgroundImage:
                      "url(" + ImagePreAddress + record.imageUrl + ")",
                    backgroundSize: "cover",
                  }}
                  width={_imageSize}
                  height={_HbeW * _imageSize}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const _onClickAnalysesExam = async (item) => {
    console.log(item);

    let url = Url.saveReportExamForStudent;

    let res = await props.actions.CallCoreServicesActionWithToken(url, item);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ alignSelf: "center", width: "80%" }}>
        <Table
          columns={Columns}
          dataSource={props.coreData[Url.getStudentList]?.[Url.action]?.data}
          loading={props.coreData[Url.getStudentList]?.[Url.action]?.isFetching}
          rowKey={(o) => o.id}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                _onClickRowStudent(record);
              }, // click row
            };
          }}
        />
      </div>
      <div style={{ alignSelf: "center", width: "80%" }}>
        <Table
          columns={ColumnListExam}
          dataSource={
            props.coreData[Url.GetImageDetailForStudent]?.[Url.action]?.data
              ?.listImage
          }
          loading={
            props.coreData[Url.GetImageDetailForStudent]?.[Url.action]
              ?.isFetching
          }
          expandable={{
            expandedRowRender: (record) => {
              return _ReturnExpandRow(record);
            },
          }}
          rowKey={(o) => o.id}
        />
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportExam);
